module.exports = __webpack_public_path__ + "img/avs.95d2ae37.jpg";